/*  How this works. Quite easy, luckily:
 **  1. Create an object with a custom name (eg: hero)
 **  2. Pass this object the sizes you need (mobile, tablet, desktop, desktopL, desktopXL and/or desktopXXL).
 **     Only mobile is required
 **  3. Define the dimensions and cropping mode for this size: [width, height, mode]. Width & height are required,
 **     but can be passed 0 which will work as 'auto'. Mode is optional (mode:crop will be used as default), possible
 **     options for mode are: crop, fit, stretch
 */

const sizes = {
  pageHalfImage: {
    mobile: [375, 360],
    tablet: [1300, 440],
    desktop: [1300, 440],
  },
  pageHalfImageFullHeight: {
    mobile: [375, 570],
    tablet: [820, 1200],
    desktop: [820, 1200],
  },
  pageFullImage: {
    mobile: [375, 605],
    tablet: [1440, 840],
    desktop: [1440, 840],
  },
  pageTwoColumnImage: {
    mobile: [335, 335],
    tablet: [520, 520],
    desktop: [520, 520],
  },
  pageTwoColumnImageBig: {
    mobile: [335, 375],
    tablet: [520, 600],
    desktop: [520, 600],
  },
  verticalCard: {
    mobile: [285, 420],
    tablet: [346, 500],
    desktop: [346, 500],
  },
  twoColumnImage: {
    mobile: [320, 320],
    tablet: [540, 540],
    desktop: [540, 540],
  },
  smallBanner: {
    mobile: [140, 140],
    tablet: [140, 140],
    desktop: [140, 140],
  },
  bannerImage: {
    mobile: [375, 600],
    tablet: [1440, 600],
    desktop: [1440, 600],
  },
  cardImage: {
    mobile: [315, 315],
    tablet: [540, 300],
    desktop: [540, 300],
  },
  imageSlider: {
    mobile: [285, 285],
    tablet: [540, 420],
    desktop: [540, 420],
  },
  videoPlaceholderImage: {
    mobile: [375, 210],
    tablet: [1080, 605],
    desktop: [1080, 605],
  },
};

export default sizes;
